import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { SAFE_BOTTOM } from './bookingUi';

/**
 * Sticky bottom CTA — safe-area aware, thumb-friendly.
 */
export default function MobileBottomBar({
  primaryLabel,
  onPrimary,
  primaryDisabled = false,
  primaryLoading = false,
  secondaryLabel,
  onSecondary,
  summaryTitle,
  summarySubtitle,
}) {
  return (
    <Paper
      elevation={12}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
        px: 2,
        pt: 1.5,
        pb: `calc(12px + ${SAFE_BOTTOM})`,
        borderRadius: '20px 20px 0 0',
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      {(summaryTitle || summarySubtitle) && (
        <Box sx={{ mb: 1 }}>
          {summaryTitle ? (
            <Typography variant="subtitle2" sx={{ fontWeight: 800, lineHeight: 1.25 }}>
              {summaryTitle}
            </Typography>
          ) : null}
          {summarySubtitle ? (
            <Typography variant="caption" color="text.secondary">
              {summarySubtitle}
            </Typography>
          ) : null}
        </Box>
      )}
      <Stack direction="row" spacing={1} alignItems="stretch">
        {secondaryLabel && onSecondary ? (
          <Button
            variant="outlined"
            onClick={onSecondary}
            sx={{ minHeight: 48, flex: '0 0 auto', px: 2, fontWeight: 700 }}
          >
            {secondaryLabel}
          </Button>
        ) : null}
        <Button
          variant="contained"
          fullWidth
          disabled={primaryDisabled || primaryLoading}
          onClick={onPrimary}
          sx={{
            minHeight: 48,
            fontWeight: 800,
            fontSize: '1rem',
            borderRadius: 2,
            boxShadow: 'none',
          }}
        >
          {primaryLabel}
        </Button>
      </Stack>
    </Paper>
  );
}

/** Spacer so content isn't hidden behind the bar. */
export function MobileBottomBarSpacer({ tall = false }) {
  return <Box sx={{ height: tall ? 120 : 96, flexShrink: 0 }} />;
}
